import { LockOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React, { FC } from "react";

type WorkspaceItemButtonProps = {
  onClick: () => void;
  disabled: boolean;
  icon?: React.ReactNode;
  mandatory?: boolean;
  workspaceItemType: string;
};

export const WorkspaceItemButton: FC<WorkspaceItemButtonProps> = (props) => {
  return props.mandatory ? (
    <Tooltip title={`This ${props.workspaceItemType} is mandatory.`}>
      <LockOutlined />
    </Tooltip>
  ) : (
    <Button
      icon={props.icon}
      shape="circle"
      type="link"
      onClick={props.onClick}
      disabled={props.disabled}
    />
  );
};
